var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PartnerPage',{attrs:{"title":"Service Logs","doc":_vm.doc}},[_c('div',{staticClass:"link-box"},[_c('YearSelector',{on:{"select":_vm.load}}),_c('IconBtn',{attrs:{"title":"Create","icon":"add"},on:{"click":_vm.create}})],1),_c('List',{staticClass:"my-3",attrs:{"items":_vm.service_logs}}),_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }